import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  Link
} from '../'

import Styles from './RetirementPlanListFFF.css'


@CSSModules(Styles,{allowMultiple:true})
export default class RetirementPlanList extends Component {
  render() {
    const companies = Object.keys(config.planNames).map((key, i) => {
      return {
        company: config.planNames[key].short_name,
        logo: require(
          `../../../static/images/plans/${config.planNames[key].path}.png`
        ),
        path: key,
      }
    })

    //
    return (
      <div styleName='cs-out'>
        <div styleName='cs-tl-sub'>
          Select a company retirement plan
        </div>
        <div styleName='pos-rel'>
          { /* Company picker */ }
          <div styleName='company-picker-flex'>
            {
              companies.map((e, i)=>{
                return (
                  <h3
                    key={'cmpny-' + i}
                    styleName={'company-picker-cell company-picker-actv'}
                  >
                    <Link
                      to={config.links.iyvPlans + '/' + e.path}
                      title={e.company}
                    >
                      <div styleName='company-picker-cell-inner'>
                        <div styleName='company-picker-cell-grow'>
                          <img
                            src={e.logo}
                            alt={e.company}
                            styleName='company-picker-img'
                          />
                        </div>
                      </div>
                    </Link>
                  </h3>
                )
              })
            }
          </div>
        </div>
      </div>
    )
  }
}